<template>
    <div class="">
        <p class="q-display-1" v-if="editMode">
            Edycja "{{article && article.title}}"
            <refresh-component observe="`article-${article.articleId}`"/>
        </p>
        <p class="q-display-1" v-else>
            Definiowanie nowego artykułu
            <refresh-component observe="`article-${article.articleId}`"/>
        </p>

        <div class="wrapper"
             @dragover.prevent="() => {}"
             @dragleave="() => {}"
             @dragenter="() => {}"
             @drop="drop"
        >
            <ArticleComponent
                :inline="true"
                :model="article"
                :in-edit="true"
                v-if="article"
                :kb="kb"
                @valid="v => articleValid = v"/>

            <template v-if="article">
                <draggable :list="article.parts" style="display: inline">
                    <article-part-component
                        class="q-ma-sm"
                        :inEdit="true"
                        :inline="true"
                        v-for="part in article.parts"
                        :key="part.id"
                        :model="part"
                        @delete="deletePart(part)"/>
                </draggable>
            </template>

            <q-btn icon="add_circle"
                   color="primary"
                   flat
                   style="font-size: 1.5rem" dense
                   round
                   @click="createNeArticlePart"/>
        </div>

        <fixed-buttons>
            <q-btn
                flat
                style="font-size: 1.5rem" dense
                icon="save"
                class="q-pa-sm"
                color="primary"
                :disable="! articleValid"
                @click="save">
                <q-tooltip anchor="top left">
                    Zapisz
                </q-tooltip>
            </q-btn>
        </fixed-buttons>
    </div>
</template>

<script>
    import QInput from 'quasar-framework/src/components/input/QInput'
    import QEditor from 'quasar-framework/src/components/editor/QEditor'
    import QTimeline from 'quasar-framework/src/components/timeline/QTimeline'
    import QTimelineEntry from 'quasar-framework/src/components/timeline/QTimelineEntry'
    import QIcon from 'quasar-framework/src/components/icon/QIcon'
    import QTooltip from 'quasar-framework/src/components/tooltip/QTooltip'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import ArticleComponent from './pole/ArticleComponent'
    import FixedButtons from './FixedButtons'
    import ArticlePartComponent from './pole/ArticlePartComponent'
    import draggable from 'vuedraggable'
    import QCardTitle from 'quasar-framework/src/components/card/QCardTitle'
    import RefreshComponent from './RefreshComponent'

    export default {
        name: 'ArticleEditor',
        components: {
            RefreshComponent,
            QCardTitle,
            ArticlePartComponent,
            FixedButtons,
            ArticleComponent,
            QBtn,
            QTooltip, QIcon, QTimelineEntry, QTimeline, QEditor, QInput,
            draggable
        },
        data () {
            return {
                newArticle: {
                    articleId: this.$uuid(),
                    version: 1,
                    title: 'Nowy artykuł',
                    summary: '',
                    minUserLevel: 0,
                    canBeTask: false,
                    parts: [],

                    isNew: true,
                },
                articleValid: true
            }
        },
        mounted () {
            // this.fetch()
            this.$store.commit('showRightMenu', {
                showAudio: true,
                showVideo: true,
                showPicture: true,
            })
        },
        destroyed () {
            this.$store.commit('showRightMenu', false)
        },
        computed: {
            editMode () {
                return this.$route.params.articleId
            },
            article () {
                if (this.editMode) {
                    return this.$store.state.article.find(a => a.articleId === this.$route.params.articleId)
                }

                return this.newArticle
            },
            kb () {
                return this.$route.name === 'article-add' || this.$route.name === 'article-edit'
            }
        },
        methods: {
            createNeArticlePart () {
                const part = {
                    articleId: this.article.articleId,
                    articlePartId: this.$uuid(),
                    category: 'text', // text / video / audio / picture
                    text: '',
                    url: '',
                    backgroundUrl: undefined,
                    backgroundColor: undefined,
                }

                this.article.parts.push(part)
            },
            drop () {
                // ...
            },
            deletePart (part) {
                this.article.parts = this.article.parts.filter(p => p.articlePartId !== part.articlePartId)
            },
            save () {
                if (this.article) {
                    const model = {
                        articleId: this.article.articleId,
                        version: this.article.version,
                        group: this.article.group,
                        title: this.article.title,
                        summary: this.article.summary,
                        minUserLevel: this.article.minUserLevel,
                        canBeTask: this.article.canBeTask,
                        ...!this.kb ? {category: this.article.category} : {},
                        ...this.kb ? {kbCategory: this.article.kbCategory} : {},
                        parts: this.article.parts.map((p, index) => {
                            return {
                                articlePartId: p.articlePartId,
                                articleId: this.article.articleId,
                                category: p.category,
                                text: p.text,
                                title: p.title,
                                url: p.url,
                                pos: index,
                                backgroundUrl: p.backgroundUrl,
                                backgroundColor: p.backgroundColor
                            }
                        })
                    }

                    if (this.article.isNew) {
                        this.$store.dispatch('create', {
                            what: 'article',
                            item: model,
                            id: this.article.articleId
                        }).then(() => {
                            if (this.kb) {
                                this.$router.push({name: 'article-edit', params: {articleId: this.article.articleId}})
                            } else {
                                this.$router.push({name: 'polearticles-edit', params: {articleId: this.article.articleId}})
                            }
                        })

                    } else {
                        this.$store.dispatch('update', {
                            what: 'article',
                            item: model,
                            id: this.article.articleId
                        })
                    }
                }
            },
        },
    }
</script>

<style scoped lang="scss">
    .wrapper {
        border: 2px solid gray;
        border-radius: 20px;
    }
</style>